import React, { useContext } from 'react';
import {
  AppContext,
  COMMON_CONSTANTS,
  StateCountryLabel
} from '@nile/components';
import { FormattedMessage } from 'react-intl';
import { DisplayText, TextStyle } from '@superops/ui-design-system';

const SiteInsight = (props) => {
  const { data } = props;

  const appContext = useContext(AppContext);
  const { companyInfo } = appContext;

  if (!data) {
    return <>NA</>;
  }

  const { address } = data;

  return (
    <>
      <div className="fw g10 mt10 mb20 ">
        <div className="fx col mb25">
          <div className="entity-heading mb8">
            <FormattedMessage id="client.details.site.address" />
          </div>
          {address?.line1 && (
            <div>
              <b>{address.line1}</b>
            </div>
          )}
          {address?.line2 && (
            <div>
              <b>{address.line2}</b>
            </div>
          )}
          {address?.line3 && (
            <div>
              <b>{address.line3}</b>
            </div>
          )}

          {address?.city && (
            <div>
              <b>{address.city}</b>
            </div>
          )}

          {address?.postalCode && (
            <div>
              <b>{address.postalCode}</b>
            </div>
          )}

          {address?.countryCode && address?.stateCode && (
            <div>
              <b>
                <StateCountryLabel
                  countryCode={address.countryCode}
                  stateCode={address.stateCode}
                />
              </b>
            </div>
          )}

          {address?.countryCode && (
            <div>
              <b>
                <StateCountryLabel countryCode={address.countryCode} />
              </b>
            </div>
          )}

          {!address?.line1 &&
            !address?.line2 &&
            !address?.line3 &&
            !address?.city &&
            !address?.countryCode &&
            !address?.stateCode && <b>NA</b>}
        </div>

        <div className="fx col mb25">
          <div className="entity-heading mb8">
            <FormattedMessage id="attribute.contactNumber" />
          </div>
          <div>
            <b>{data?.contactNumber || 'NA'}</b>
          </div>
        </div>

        <div className="fx col mb25">
          <div className="entity-heading mb8">
            <FormattedMessage id="client.details.site.timezone" />
          </div>
          <div>
            <b>
              {data?.timezoneCode
                ? `${data?.timezoneCode} ${
                    COMMON_CONSTANTS.TIMEZONES?.[data?.timezoneCode]
                      ? `${COMMON_CONSTANTS.TIMEZONES?.[data?.timezoneCode]}`
                      : ''
                  }`
                : 'NA'}
            </b>
          </div>
        </div>

        <div className="fx col mb25">
          <div className="entity-heading mb8">
            <FormattedMessage id="admin.slaPolicy.executeIn.businessHrs" />
          </div>
          <div>
            {data?.working24x7 && (
              <>
                <b>
                  <FormattedMessage id="client.details.site.working24" />
                </b>
              </>
            )}
            {data?.businessHour && !data?.working24x7 && (
              <>
                <div className="flex g30">
                  <div>
                    <div className="col-heading uppercase mb6 fsize12">
                      <FormattedMessage id="client.details.site.workingdays" />
                    </div>

                    {data?.businessHour.map((el) => {
                      return (
                        <div className="col-content day mb-8 lowercase first-letter-capitalize">
                          <DisplayText element="p" size="large">
                            {el?.day}
                          </DisplayText>
                        </div>
                      );
                    })}
                  </div>

                  <div>
                    <div className="col-heading uppercase mb6 fsize12">
                      <FormattedMessage id="client.details.site.starthour" />
                    </div>

                    {data?.businessHour.map((el) => {
                      return (
                        <p className="col-content bold mb-8 lowercase bold">
                          {el?.start}
                        </p>
                      );
                    })}
                  </div>

                  <div>
                    <div className="col-heading uppercase mb6 fsize12">
                      <FormattedMessage id="client.details.site.endhour" />
                    </div>

                    {data?.businessHour.map((el) => {
                      return (
                        <p className="col-content bold mb-8 lowercase bold">
                          {el?.end}
                        </p>
                      );
                    })}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="fx col mb25">
          <div className="entity-heading mb8">
            <FormattedMessage id="entity.holiday" />
          </div>
          <div>
            <b>{data?.holidayList?.name || 'NA'}</b>
          </div>
        </div>
      </div>
    </>
  );
};

export default SiteInsight;
